/*
 * @Author: lzy
 * @Date: 2021-05-11 15:53:07
 * @LastEditTime: 2021-05-12 11:06:13
 * @LastEditors: lzy
 * @Description: app详情页顶部操作按钮
 * @FilePath: \xjmediacloud\app\editingCenter\app\directive\previewBtns\previewBtns.js
 */

angular.module('wbPreviewModule').directive('wbPreviewBtns', ['$state', '$q', 'editingCenterWeiBoService', 'editCenUploadVideoForXjService', 'storageListenerService', 'noticeWindowService', 'editingCenterService', 'modalDialog', 'publicToolService', 'trsHttpService', 'newMediaService', 'weiboApiParams', 'weiboApiService', 'weiboConst', 'messagePublishService',
    function($state, $q, editingCenterWeiBoService, editCenUploadVideoForXjService, storageListenerService, noticeWindowService, editingCenterService, modalDialog, publicToolService, trsHttpService, newMediaService, weiboApiParams, weiboApiService, weiboConst, messagePublishService) {
        return {
            scope: true,
            restrict: 'EA',
            replace: true,
            templateUrl: './editingCenter/weibo/preview/previewBtns/previewBtns.html',
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 初始化数据
                 *
                 * @return  {[type]}   [return description]
                 */
                function initStatus() {
                    angular.extend($scope.data, {
                        flowFlag: { // 判断属于哪个流程
                            0: '40',
                            1: '20'
                        },
                        trench: weiboConst.listenStroageKey,
                    });
                    $scope.list = $scope.data.wbInfo;
                }

                /**
                 * [initData description]
                 *
                 * @return  {[type]}   [return description]
                 */
                function initData() {
                    publicToolService.getModeconfiguration('IM').then((config) => {
                        // 因为发送按钮不基于权限控制，只根据配置中心来决定，在这里添加可以便于修改每个编辑页面
                        $scope.status.canSendMessage = config && config.sendSwitch === 'on';
                    });
                }

                /* 送审 */
                $scope.trial = function() {
                    if (angular.isDefined($scope.data.wbInfo.FGDERROR) && $scope.data.wbInfo.FGDERROR === '1') {
                        modalDialog.alertType('稿件不完整，请先完善稿件信息', '', 'error', 'confirm');
                    } else {
                        isLock().then(function() {
                            newMediaService.trial($scope, {serviceid: 'wcm61_scmmicrocontent', methodname: 'processToTrialToJson'}).then(function() {
                                let trialParams = angular.extend({
                                    ObjectIds: $scope.data.wbInfo.METADATAID,
                                }, {serviceid: 'wcm61_scmmicrocontent', methodname: 'processToTrialToJson'});
                                messagePublishService.publish('doEditPageOperation', trialParams);
                            });
                        });
                    }
                };

                /* 直接签发 */
                $scope.sign = function(type) {
                    var tip = type === 'directive' ? '直接签发' : '定时签发';
                    if (angular.isDefined($scope.data.wbInfo.FGDERROR) && $scope.data.wbInfo.FGDERROR === '1') {
                        modalDialog.alertType('稿件不完整，请先完善稿件信息', '', 'error', 'confirm', function () { });
                    } else if (editingCenterWeiBoService.hasIllegalDoc([$scope.data.wbInfo])) {
                        modalDialog.alertType('', '长文本微博不能附带图片' + tip + '！请重新编辑', 'error', 'confirm');
                    } else {
                        if ($scope.data.wbInfo.VIDEOREL && $scope.data.wbInfo.VIDEOREL.length) {
                            editCenUploadVideoForXjService.getVideoMark($scope.data.wbInfo.VIDEOREL[0]).then(function (data) {
                                if (data.status !== 1) {
                                    modalDialog.alertType(tip + '失败！', '视频转码未完成，请稍后再试', 'error', 'confirm', function () { });
                                } else {
                                    sign(type);
                                }
                            });
                        } else {
                            sign(type);
                        }
                    }
                };

                /**
                 * [sign description] 用于判断是定时签发还是直接签发
                 *
                 * @param  {[type]}  type   [type description]
                 *
                 * @return  {[type]}   [return description]
                 */
                function sign(type) {
                    switch (type) {
                        case 'directive':
                            signPrivate();
                            break;
                        case 'time':
                            timeSign();
                            break;
                    }
                }

                /**
                 * [signPrivate description] 直接签发
                 *
                 * @return  {[type]}   [return description]
                 */
                function signPrivate() {
                    $scope.loadingPromise = noticeWindowService.getAccountValidityInfo($scope.data.wbInfo.MEDIATYPE).then(function() {
                        editingCenterWeiBoService.directSignWeibo([$scope.data.wbInfo], false, $scope.data.flowFlag[$scope.status.plantform], function (result) {
                            modalDialog.alertType('直接签发成功', '', 'success', false, function() {
                                afterOper();
                            });
                        }, function () {
                        });
                    });
                }

                /**
                 * [timeSign description] 定时签发
                 *
                 * @return  {[type]}   [return description]
                 */
                function timeSign() {
                    $scope.loadingPromise = noticeWindowService.getAccountValidityInfo($scope.data.wbInfo.MEDIATYPE).then(function () {
                        editingCenterWeiBoService.timeSignWeibo([$scope.data.wbInfo], false, $scope.data.flowFlag[$scope.status.plantform], function(result) {
                            editingCenterWeiBoService.unlockWeibo(JSON.parse($state.params.wbmetadataid));
                            modalDialog.alertType('定时签发成功', '', 'success', false, function() {
                                afterOper();
                            }, '', 1500);
                        });
                    }
                    );
                }

                /* 废稿 */
                $scope.deleteDraft = function() {
                    isLock().then(function() {
                        modalDialog.alertType('', '是否确认将此微博置为废稿', 'ask', true, function () {
                            var params = {
                                serviceid: 'wcm61_scmmicrocontent',
                                methodname: 'abolishMicroContent',
                                MicroContentId: $scope.data.wbInfo.METADATAID,
                                AccountId: $state.params.wbchannelid,
                                opinion: '',
                            };
                            $scope.status.isEsSearch = false;
                            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                                modalDialog.alertType('废稿成功', '', 'success', false);
                                afterOper();
                            });
                        });
                    });
                };

                // 撤稿
                $scope.revoke = function() {
                    editingCenterWeiBoService.withdrawWeibo([$scope.data.wbInfo], function() {
                        modalDialog.alertType('撤稿成功', '', 'success', false, function() {
                            afterOper();
                        }, '', 1500);
                    });
                };

                /**
                 * [revise description]修订
                 * @return {[type]} [description]
                 */
                $scope.revise = function () {
                    var transferData = {
                        serviceid: 'mlf_modifydoc',
                        methodname: 'appointDocToUserOfNewMedia',
                        SiteId: $state.params.wbchannelid,
                        DocIds: $scope.data.wbInfo.METADATAID,
                        UserId: '',
                        MediaType: '5',
                    };
                    newMediaService.revise($scope, transferData).then(function() {
                        afterOper();
                    });
                };

                // 取消签发
                $scope.retraction = function() {
                    modalDialog.inputModel('是否取消签发', '取消签发原因 (选填)', function (content) {
                        let params = angular.extend({}, weiboApiParams.cancelSignParams, {
                            MicroContentId: $scope.data.wbInfo.METADATAID,
                            AccountId: $state.params.wbchannelid,
                            option: content,
                        });
                        $scope.status.isEsSearch = false;
                        $scope.loadingPromise = weiboApiService.cancelSign(params).then(function (data) {
                            modalDialog.alertType('取消签发成功', '', 'success', false, function() {
                                afterOper();
                            });
                        });
                    });
                };

                /**
                 * [tenantManuShare 租户间共享]
                 * @return {[type]} [description]
                 */
                $scope.tenantManuShare = function () {
                    var params = {
                        serviceid: 'wcm61_scmmicrocontent',
                        methodname: 'pluralisticShare',
                        ObjectId: $scope.data.wbInfo.METADATAID,
                    };
                    $scope.loadingPromise = editingCenterService.tenantShareManu(params);
                };

                /**
                 * [isLock description] 判断稿件是否被锁定
                 *
                 * @return  {[type]}   [return description]
                 */
                function isLock() {
                    var defer = $q.defer();
                    editingCenterWeiBoService.isLock($scope.data.wbInfo.METADATAID).then(function (lockSituation) {
                        if (lockSituation.ISLOCK === 'false') {
                            defer.resolve();
                        } else {
                            modalDialog.alertType(lockSituation.LOCKUSERDEPT ? '当前微博已被【' + lockSituation.LOCKUSERDEPT + '-' + lockSituation.LOCKUSER + '】锁定，您此时不能送审' : '当前微博已被【' + lockSituation.LOCKUSER + '】锁定，您此时不能送审', '', 'warning', 'confirm');
                            defer.reject();
                        }
                    });
                    return defer.promise;
                }

                /**
                 * [afterOper description] 操作后执行
                 *
                 * @return  {[type]}   [return description]
                 */
                function afterOper() {
                    storageListenerService.addListenerToWeibo('directSign');
                    window.close();
                }
            }
        };
    }
]);
